module.exports = __webpack_public_path__ + "a1f8b15e1f0b1eb32e32a2742d9914c4.jpg";